// import React, { useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Send() {
//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [code, setCode] = useState("");
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState("");

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     setFile(selectedFile);
//     setCode("");
//     setError("");
//     if (selectedFile && selectedFile.type.startsWith("image/")) {
//       setPreview(URL.createObjectURL(selectedFile));
//     } else {
//       setPreview(null);
//     }
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       setError("Please select a file");
//       return;
//     }
//     setUploading(true);
//     const formData = new FormData();
//     formData.append("file", file);
//     const token = localStorage.getItem("token");

//     try {
//       const res = await axios.post(`${API_BASE_URL}/upload`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setCode(res.data.code);
//       setError("");
//       alert("Upload successful!");
//     } catch (err) {
//       setError(err.response?.data?.error || "Upload failed");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const styles = {
//     container: {
//       padding: "20px",
//       backgroundColor: "#f4f4f9",
//       minHeight: "100vh",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#333",
//       marginBottom: "20px",
//     },
//     fileLabel: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       height: "150px",
//       border: "2px dashed #ff3366",
//       borderRadius: "8px",
//       cursor: "pointer",
//       backgroundColor: "#fff",
//       transition: "background-color 0.3s",
//     },
//     fileLabelHover: {
//       backgroundColor: "#fff5f7",
//     },
//     fileInput: {
//       display: "none",
//     },
//     fileText: {
//       fontSize: "16px",
//       color: "#666",
//       marginTop: "10px",
//     },
//     preview: {
//       maxWidth: "200px",
//       marginTop: "10px",
//       borderRadius: "8px",
//       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//     },
//     button: {
//       marginTop: "20px",
//       padding: "10px 20px",
//       backgroundColor: "#ff3366",
//       color: "#fff",
//       border: "none",
//       borderRadius: "4px",
//       fontSize: "16px",
//       cursor: "pointer",
//       transition: "background-color 0.3s",
//     },
//     buttonDisabled: {
//       backgroundColor: "#ccc",
//       cursor: "not-allowed",
//     },
//     buttonHover: {
//       backgroundColor: "#e02e5c",
//     },
//     error: {
//       marginTop: "15px",
//       color: "#e53e3e",
//       fontSize: "14px",
//     },
//     code: {
//       marginTop: "15px",
//       fontSize: "16px",
//       color: "#333",
//     },
//     codeSpan: {
//       fontWeight: "bold",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>Send Files</h2>
//       <label
//         htmlFor="fileInput"
//         style={styles.fileLabel}
//         onMouseOver={(e) => (e.target.style.backgroundColor = styles.fileLabelHover.backgroundColor)}
//         onMouseOut={(e) => (e.target.style.backgroundColor = styles.fileLabel.backgroundColor)}
//       >
//         <span style={{ fontSize: "36px", color: "#ff3366" }}>+</span>
//       </label>
//       <input
//         id="fileInput"
//         type="file"
//         style={styles.fileInput}
//         onChange={handleFileChange}
//       />
//       {file && (
//         <div>
//           <p style={styles.fileText}>Selected File: {file.name}</p>
//           {preview && <img src={preview} alt="preview" style={styles.preview} />}
//           <button
//             onClick={handleUpload}
//             disabled={uploading}
//             style={{
//               ...styles.button,
//               ...(uploading ? styles.buttonDisabled : {}),
//             }}
//             onMouseOver={(e) => !uploading && (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
//             onMouseOut={(e) => !uploading && (e.target.style.backgroundColor = styles.button.backgroundColor)}
//           >
//             {uploading ? "Uploading..." : "Upload"}
//           </button>
//         </div>
//       )}
//       {error && <p style={styles.error}>{error}</p>}
//       {code && (
//         <p style={styles.code}>
//           Share this code: <span style={styles.codeSpan}>{code}</span>
//         </p>
//       )}
//     </div>
//   );
// }

// export default Send;



import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

function Send() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [code, setCode] = useState("");
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setCode("");
    setError("");
    if (selectedFile && selectedFile.type.startsWith("image/")) {
      setPreview(URL.createObjectURL(selectedFile));
    } else {
      setPreview(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file");
      return;
    }
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(`${API_BASE_URL}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setCode(res.data.code);
      setError("");
      alert("Upload successful!");
    } catch (err) {
      setError(err.response?.data?.error || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const styles = {
    container: {
      padding: "50px",
      backgroundColor: "#f4f4f9",
      minHeight: "100vh",
      marginLeft: "220px",
      transition: "margin-left 0.3s ease",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "20px",
    },
    fileLabel: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "150px",
      border: "2px dashed #ff3366",
      borderRadius: "8px",
      cursor: "pointer",
      backgroundColor: "#fff",
      transition: "background-color 0.3s",
      maxWidth: "600px",
    },
    fileLabelHover: {
      backgroundColor: "#fff5f7",
    },
    fileInput: {
      display: "none",
    },
    fileText: {
      fontSize: "16px",
      color: "#666",
      marginTop: "10px",
      wordBreak: "break-word",
    },
    preview: {
      maxWidth: "200px",
      marginTop: "10px",
      borderRadius: "8px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    },
    button: {
      marginTop: "20px",
      padding: "10px 20px",
      backgroundColor: "#ff3366",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      width: "100%",
      maxWidth: "200px",
    },
    buttonDisabled: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    buttonHover: {
      backgroundColor: "#e02e5c",
    },
    error: {
      marginTop: "15px",
      color: "#e53e3e",
      fontSize: "14px",
    },
    code: {
      marginTop: "15px",
      fontSize: "16px",
      color: "#333",
      wordBreak: "break-word",
    },
    codeSpan: {
      fontWeight: "bold",
    },
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            .send-container {
              margin-left: 0 !important;
              padding: 15px !important;
            }
            
            .send-heading {
              font-size: 20px !important;
              margin-top: 50px !important;
            }
            
            .file-label {
              height: 120px !important;
            }
            
            .upload-button {
              max-width: 100% !important;
            }
          }

          @media (max-width: 480px) {
            .send-container {
              padding: 12px !important;
            }
            
            .send-heading {
              font-size: 18px !important;
            }
            
            .file-label {
              height: 100px !important;
            }
            
            .file-text {
              font-size: 14px !important;
            }
            
            .preview-image {
              max-width: 150px !important;
            }
          }
        `}
      </style>
      <div className="send-container" style={styles.container}>
        <h2 className="send-heading" style={styles.heading}>Send Files</h2>
        <label
          htmlFor="fileInput"
          className="file-label"
          style={styles.fileLabel}
          onMouseOver={(e) => (e.target.style.backgroundColor = styles.fileLabelHover.backgroundColor)}
          onMouseOut={(e) => (e.target.style.backgroundColor = styles.fileLabel.backgroundColor)}
        >
          <span style={{ fontSize: "36px", color: "#ff3366" }}>+</span>
        </label>
        <input
          id="fileInput"
          type="file"
          style={styles.fileInput}
          onChange={handleFileChange}
        />
        {file && (
          <div>
            <p className="file-text" style={styles.fileText}>Selected File: {file.name}</p>
            {preview && <img src={preview} alt="preview" className="preview-image" style={styles.preview} />}
            <button
              onClick={handleUpload}
              disabled={uploading}
              className="upload-button"
              style={{
                ...styles.button,
                ...(uploading ? styles.buttonDisabled : {}),
              }}
              onMouseOver={(e) => !uploading && (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
              onMouseOut={(e) => !uploading && (e.target.style.backgroundColor = styles.button.backgroundColor)}
            >
              {uploading ? "Uploading..." : "Upload"}
            </button>
          </div>
        )}
        {error && <p style={styles.error}>{error}</p>}
        {code && (
          <p style={styles.code}>
            Share this code: <span style={styles.codeSpan}>{code}</span>
          </p>
        )}
      </div>
    </>
  );
}

export default Send;
